import Grid from '@mui/material/Grid';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';

interface SkillSetForm {
  skillsetID?: number;
}

export const SkillSetForm = ({ skillsetID }: SkillSetForm) => {
  const options = [
    {
      value: 'Active',
      label: 'Active',
      isDefault: true,
    },
    {
      value: 'Inactive',
      label: 'Inactive',
      isDefault: false,
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Skill Set Name" name="skillsetName" maxLength={150} multiline={false} autoFocus />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Code" name="skillsetCode" maxLength={150} multiline={false} disabled={!!skillsetID} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Note" name="notes" maxLength={150} multiline={true} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormSelect label="Status" name="status" options={options} />
      </Grid>
    </Grid>
  );
};
